export class TagDetails
{
    constructor()
    {
        this.idTagsDetails = -1
        this.fontPrice = 8
        this.fontName = 8
        this.marginLeft = 4
        this.marginTop = 3
        this.labelMarginLeft = 3
        this.labelHeight = 3
        this.labelMargin = 1
        this.BarHeight = 6
        this.BarWidgh = 35
        this.marginNextTag = 20
        this.pageW = 80
        this.pageH = 500
    }
    
    fromCloud(data){
        this.idTagsDetails = data.idTagsDetails
        this.fontPrice = data.fontPrice
        this.fontName = data.fontName
        this.marginLeft = data.marginLeft
        this.marginTop = data.marginTop
        this.labelMarginLeft = data.labelMarginLeft
        this.labelHeight = data.labelHeight
        this.labelMargin = data.labelMargin
        this.BarHeight = data.BarHeight
        this.BarWidgh = data.BarWidgh
        this.marginNextTag = data.marginNextTag
        this.pageW = data.pageW
        this.pageH = data.pageH
    }

    getMapFromCloud(){
        return{
          'idTagsDetails':this.idTagsDetails,
          'fontPrice': this.fontPrice,
          'fontName': this.fontName,
          'marginLeft': this.marginLeft,
          'marginTop': this.marginTop,
          'labelMarginLeft': this.labelMarginLeft,
          'labelHeight': this.labelHeight,
          'labelMargin': this.labelMargin,
          'BarHeight':this.BarHeight,
          'BarWidgh' : this.BarWidgh,
          'marginNextTag':this.marginNextTag,
          'pageW': this.pageW,
          'pageH': this.pageH,
        }
    }
}